// extracted by mini-css-extract-plugin
module.exports = {"container":"OQkY2AIZJn9-x_UAlFBLw postfix m-checkbox"};